export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_bg.a778fe1b25159342.json"